export default "__VITE_ASSET__BZkdn5Jx__"